// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Uncurried = require("../Effect.Uncurried/index.js");
var Specular_Internal_Profiling = require("../Specular.Internal.Profiling/index.js");
var measure = function (dictMonadEffect) {
    if (Specular_Internal_Profiling.enabled) {
        return function (name) {
            return function (action) {
                return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(function () {
                    return Specular_Internal_Profiling.begin(name);
                }))(function (mark) {
                    return Control_Bind.bind((dictMonadEffect.Monad0()).Bind1())(action)(function (result) {
                        return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadEffect.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(function () {
                            return Specular_Internal_Profiling.end(mark);
                        }))(function () {
                            return Control_Applicative.pure((dictMonadEffect.Monad0()).Applicative0())(result);
                        });
                    });
                });
            };
        };
    };
    return function (v) {
        return function (action) {
            return action;
        };
    };
};
var end = (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.end);
    };
    return function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Data_Unit.unit);
    };
})();
var begin = (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.begin);
    };
    return function (v) {
        return Control_Applicative.pure(Effect.applicativeEffect)(Specular_Internal_Profiling.none);
    };
})();
module.exports = {
    begin: begin,
    end: end,
    measure: measure
};
//# sourceMappingURL=index.js.map
